import React from 'react'
import { Bar, Line } from 'react-chartjs-2'
import moment from 'moment'
import ChartCard from './ChartCard'
import { baseChartOptions, viz } from './overviewTheme'

// Incidents reported per month — single series, one hue, thin rounded bars
export const IncidentsTrendChart = ({ incidentsByMonth = [] }) => {
  const labels = incidentsByMonth.map((m) =>
    moment(m.month, 'YYYY-MM').format('MMM'),
  )
  const counts = incidentsByMonth.map((m) => m.count)

  return (
    <ChartCard
      title="Incidents reported"
      subtitle="Last 6 months"
      columns={['Month', 'Incidents']}
      rows={incidentsByMonth.map((m) => [
        moment(m.month, 'YYYY-MM').format('MMMM YYYY'),
        m.count,
      ])}
    >
      <Bar
        aria-label="Bar chart of incidents reported per month over the last six months"
        data={{
          labels,
          datasets: [
            {
              label: 'Incidents',
              data: counts,
              backgroundColor: viz.series,
              maxBarThickness: 20,
              borderRadius: { topLeft: 4, topRight: 4 },
              borderSkipped: 'bottom',
            },
          ],
        }}
        options={{
          ...baseChartOptions,
          plugins: {
            ...baseChartOptions.plugins,
            tooltip: {
              ...baseChartOptions.plugins.tooltip,
              callbacks: {
                label: (ctx) =>
                  ` ${ctx.raw} incident${ctx.raw === 1 ? '' : 's'}`,
              },
            },
          },
        }}
      />
    </ChartCard>
  )
}

// Shifts delivered per week — 2px line with a light wash and a ringed end-dot
export const ShiftTempoChart = ({ shiftsByWeek = [] }) => {
  const labels = shiftsByWeek.map((w) => moment(w.weekStart).format('D MMM'))
  const counts = shiftsByWeek.map((w) => w.count)
  const lastIndex = counts.length - 1

  return (
    <ChartCard
      title="Operational tempo"
      subtitle="Shifts per week, last 8 weeks"
      columns={['Week beginning', 'Shifts']}
      rows={shiftsByWeek.map((w) => [
        moment(w.weekStart).format('D MMMM YYYY'),
        w.count,
      ])}
    >
      <Line
        aria-label="Line chart of shifts per week over the last eight weeks"
        data={{
          labels,
          datasets: [
            {
              label: 'Shifts',
              data: counts,
              borderColor: viz.series,
              borderWidth: 2,
              tension: 0.35,
              fill: true,
              backgroundColor: viz.seriesSoft,
              pointRadius: counts.map((_, i) => (i === lastIndex ? 4 : 0)),
              pointHoverRadius: 5,
              pointBackgroundColor: viz.series,
              pointBorderColor: viz.surface,
              pointBorderWidth: 2,
            },
          ],
        }}
        options={{
          ...baseChartOptions,
          plugins: {
            ...baseChartOptions.plugins,
            tooltip: {
              ...baseChartOptions.plugins.tooltip,
              callbacks: {
                label: (ctx) => ` ${ctx.raw} shift${ctx.raw === 1 ? '' : 's'}`,
              },
            },
          },
        }}
      />
    </ChartCard>
  )
}
